// Owner: scheduling (owner feedback F13). The one way to start "Book a meeting" from anywhere: the Meetings
// page, a record's header, a task, the mail composer, the command bar. Light module (no dialog code): the
// dialog loads on first open (`src/overlays/meeting-book.tsx`).
import type { BookingDTO } from '@dataroom/core/scheduling';
import { openLayer } from '../../shell/overlays';

export type BookMeetingRequest = {
  /** The record the meeting is with (a person-like record): the booking is linked to it. */
  record?: { objectKey: string; recordId: string; title?: string; email?: string | null };
  /** Who the meeting is with, when known (a colleague, an address). */
  invitee?: { name?: string; email?: string; memberId?: string };
  /** The record the meeting is about when that is not the invitee's own (a deal, an opening). */
  context?: { objectKey: string; recordId: string; title?: string };
  /** The task the meeting is booked from (it lists the meeting afterwards). */
  taskId?: string;
  /** Start with this meeting type. */
  typeId?: string;
  /** What to call the meeting without a type. */
  title?: string;
  source?: 'internal' | 'record' | 'mail' | 'task' | 'workflow';
  /** Called with the meeting once it is booked. */
  onBooked?: (booking: BookingDTO) => void;
};

declare module '../../shell/overlays' {
  interface GlobalLayers {
    'meeting-book': BookMeetingRequest;
  }
}

export function openBookMeeting(request: BookMeetingRequest = {}) {
  openLayer('meeting-book', request);
}
